import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import log from 'loglevel';

const RecipeMarkup = (data) => {
  let frontmatter;
  try {
    frontmatter = data.data.node.frontmatter;
  } catch (err) {
    console.error({ data }, 'got bum data!');
    throw err;
  }
  log.debug({ data }, 'recipeMarkup');
  return (
    <div className="recipe-card">
      <h2 className="recipe-card--title">{frontmatter.title}</h2>
      {frontmatter.description && (
        <p className="recipe-card--description">{frontmatter.description}</p>
      )}
      <div className="recipe-card--directions">
        <MDXRenderer>{data.data.node.body}</MDXRenderer>
      </div>
    </div>
  );
};

const Recipe = (props) => {
  const data = useStaticQuery(graphql`
    query Recipe {
      allMdx(filter: { fileAbsolutePath: { regex: "/content/recipes/" } }) {
        edges {
          node {
            body
            frontmatter {
              slug
              title
              description
            }
          }
        }
      }
    }
  `);
  if (data) {
    let recipe;
    for (const item of data.allMdx.edges) {
      if (item.node.frontmatter.slug === props.slug) {
        recipe = item;
      }
    }
    if (data && !recipe) {
      throw new Error(`could not resolve recipe for item ${props.slug}`);
    }

    return <RecipeMarkup data={recipe} />;
  }
};

export default Recipe;
